module.exports = "<div id=\"injectedPasswordRecovery\" ng-show=\"loaded\">\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-login-components/src/password-recovery/template.html
 ** module id = 510
 ** module chunks = 1
 **/